import { compose } from 'redux';

export default function getComposeEnhancers() {
    const reduxDevtoolsExtensionCompose =
        window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__;
    const extensionOptions = {};

    return canInstallExtension()
        ? reduxDevtoolsExtensionCompose(extensionOptions)
        : compose;
}

function canInstallExtension() {
    return (
        typeof window === 'object' &&
        window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    );
}
